import { useTranslation } from '@conekta/cronos/i18n';
import { CheckoutFrameContext } from 'app/context/CheckoutFrameContext';
import { CardVerificationTooltipHelper } from 'app/pages/frames/components/CardVerificationTooltip/CardVerificationTooltip';
import FieldEvaluated from 'app/pages/frames/components/Form/FieldEvaluated';
import { getFormControlProps } from 'app/pages/frames/components/Form/FieldEvaluated/helpers';
import { formCardFieldNames, formControlsPropsCard } from 'app/pages/frames/components/Form/FormCard/constants';
import { getCardBrandImgUrl } from 'app/pages/frames/helpers/checkout';
import { FormApi } from 'final-form';
import { useContext, useState } from 'react';

import { selectCardProps } from '../FormCard/constants';
import './styles.scss';

interface Props {
  form: FormApi<any>;
  validateCardNumber?: any;
}

export const FormCardInformation = ({ form, validateCardNumber }: Props) => {
  const { t } = useTranslation();
  const [backgroundCardImage, setBackgroundCardImage] = useState('');
  const { checkoutRequest } = useContext(CheckoutFrameContext);
  const { excludeCardNetworks = '' } = checkoutRequest;

  const { cardNumber, cardExpMonthYear, cardVerificationValue, cardholderName } = formCardFieldNames;

  return (
    <>
      <FieldEvaluated
        {...getFormControlProps(cardNumber, selectCardProps(excludeCardNetworks), t)}
        onChange={() => {
          const { getFieldState } = form;
          const cardTypeNumber = getFieldState(formCardFieldNames.cardNumber);
          setBackgroundCardImage(getCardBrandImgUrl(cardTypeNumber?.value));
          validateCardNumber && validateCardNumber(form);
        }}
        backgroundImage={backgroundCardImage}
      />
      <div className="fields-expiration-date-and-cvv">
        {/* Expiration Month/Year */}
        <FieldEvaluated {...getFormControlProps(cardExpMonthYear, formControlsPropsCard, t)} />
        {/* CVV */}
        <FieldEvaluated
          {...getFormControlProps(cardVerificationValue, selectCardProps(excludeCardNetworks), t)}
          tooltipHelper={<CardVerificationTooltipHelper />}
        />
      </div>
      <FieldEvaluated {...getFormControlProps(cardholderName, formControlsPropsCard, t)} />
    </>
  );
};
